// extracted by mini-css-extract-plugin
export default {"loader_container":"index_loader_container__cz3vE"};